import { Box } from '@mui/material'
import styled from '@emotion/styled/macro'
import theme from 'theme'
import { PERFORMANCE_SECTION_HEIGHT } from '../../../utils'

export const Wrapper = styled(Box)`
  border-radius: ${theme.attributes.borderRadius.quaternary};
  background: ${theme.colors.backgroundDarker};

  /* Matches the loaded cards, which sit on surface-container (white) in light. */
  html[data-theme='light'] & {
    background: ${theme.colors.surfaceContainerBackground};
  }

  padding: ${theme.spacing.medium}px;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: ${PERFORMANCE_SECTION_HEIGHT}px;

  .title-wrapper {
    display: flex;
    align-items: center;
    margin-bottom: ${theme.spacing.medium}px;

    img {
      width: 16px;
      height: 16px;
    }

    .chart-title {
      color: ${theme.colors.legacyNeutral2};
      font-family: ${theme.typography.fontFamily.primary};
      font-size: ${theme.typography.fontSize.xLarge};
      font-style: normal;
      font-weight: ${theme.typography.fontWeight.bold};
      line-height: 24px;
      letter-spacing: 0.1px;
      margin-left: ${theme.spacing.xSmall}px;
    }
  }

  .inner {
    border-radius: ${theme.attributes.borderRadius.normal};
    padding: ${theme.spacing.md}px ${theme.spacing.small}px ${theme.spacing.medium}px;
    display: flex;
    gap: ${theme.spacing.medium}px;
    justify-content: center;
    overflow: hidden;

    @media (min-width: 1920px) {
      padding: 0 ${theme.spacing.small}px ${theme.spacing.medium}px;
    }

    .chart {
      display: flex;
      flex-direction: column;
      gap: 17px;
      justify-content: center;
      align-items: center;

      .chart-description {
        display: flex;
        align-items: center;
        gap: ${theme.spacing.medium}px;

        .chart-description-item {
          display: flex;
          align-items: center;

          .chart-description-icon {
            border-radius: ${theme.attributes.borderRadius.tertiary};
            background: ${theme.colors.borderLow};
            box-shadow: ${theme.attributes.boxShadow.chipCircle};
            width: 8px;
            height: 8px;
          }

          .MuiTypography-root {
            color: ${theme.colors.legacyNeutral2};
            font-family: ${theme.typography.fontFamily.primary};
            font-size: ${theme.typography.fontSize.medium};
            font-style: normal;
            font-weight: ${theme.typography.fontWeight.normal};
            line-height: 16px;
            letter-spacing: 0.4px;
            margin-left: ${theme.spacing.half}px;
          }
        }
      }
    }
  }
`
